'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _d = require('d3');

var d3 = _interopRequireWildcard(_d);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var zoomable = function zoomable(_ref) {
  var el = _ref.el,
      duration = _ref.duration;

  var zoomed = function zoomed() {
    return svg.attr('transform', d3.event.transform);
  };
  var zoom = d3.zoom().on('zoom', zoomed);

  var resetZoom = function resetZoom() {
    svg.transition().duration(duration).call(zoom.transform, d3.zoomIdentity);
  };

  var svg = d3.select(el).append('svg').attr('id', 'svg-file-container').attr('width', '100%').attr('height', '100%').call(zoom).on('dblclick.zoom', resetZoom).append('g');
  return svg;
};

exports.default = zoomable;